// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__yO0x7","active":"Menu_active__EuPtP","line":"Menu_line__vbzDc","spin":"Menu_spin__TwsMn","loader":"Menu_loader___bjVS"};